/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactLoyaltyView } from './contactLoyaltyView';
import { CityWithRegionViewDto } from './cityWithRegionViewDto';
import { CategoryView } from './categoryView';
import { EditLoyaltyProductGroup } from './editLoyaltyProductGroup';
import { MapObjectViewDto } from './mapObjectViewDto';
import { PhotoDataLoyaltyView } from './photoDataLoyaltyView';


/**
 * Просмотреть продукт программы лояльности – товар / услуга
 */
export interface ViewLoyaltyProduct { 
    /**
     * Наименование продукта лояльности.
     */
    name: string;
    /**
     * Описание продукта лояльности.
     */
    description: string;
    /**
     * Краткое описание продукта лояльности.
     */
    descriptionShort?: string;
    /**
     * ID организации продукта.
     */
    organisationId?: string;
    /**
     * ID ассоциации.
     */
    parentOrganisationId?: string;
    /**
     * Информация о компании.
     */
    organisationInfo?: string;
    /**
     * Список контактных лиц.
     */
    contacts?: Array<ContactLoyaltyView>;
    /**
     * Список фоттографий.
     */
    photos?: Array<PhotoDataLoyaltyView>;
    /**
     * Дата окончания размещения.
     */
    dateExpiration?: string;
    cities?: Array<CityWithRegionViewDto>;
    /**
     * Спимок групп получателей скидки.
     */
    discountGroups?: Array<EditLoyaltyProductGroup>;
    /**
     * ответственный сотрудник из объединения
     */
    contactUserId?: string;
    externalAuthorId?: string;
    externalOrganisationId?: string;
    externalOrganisationName?: string;
    externalOrganisationLogoId?: string;
    paidDuration?: number;
    paidBoostRateId?: string;
    paidNewsletterTier1Count?: number;
    paidNewsletterTier2Count?: number;
    paidNewsletterTier3Count?: number;
    /**
     * текст скидки.
     */
    discountText?: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    /**
     * Адреса с координатами
     */
    mapObjects?: Array<MapObjectViewDto>;
    /**
     * ID записи.
     */
    id: string;
    /**
     * TRUE - реклама; иначе FALSE.
     */
    isAdvertisment?: boolean;
    /**
     * Дата публикации продукта.
     */
    datePublished?: string;
    /**
     * вычисляемый рейтинг продукта: Непримечательное, Популярное, Заметное, Бестселлер
     */
    rating: number;
    /**
     * Статус продукта.
     */
    status: number;
    /**
     * Краткое наименование организации.
     */
    organisationShortName?: string;
    /**
     * Полное наименование организации.
     */
    organisationFullName?: string;
    /**
     * ID обложки организации.
     */
    organisationLogoId?: string;
    requestLeadContacts?: boolean;
    eridToken?: string;
    eridAdInfo?: string;
    /**
     * Признак, что продукт находится в Избранном у пользователя
     */
    isFavorite?: boolean;
    /**
     * размер скидки.
     */
    discount?: string;
    /**
     * Список ID категорий.
     */
    categories: Array<CategoryView>;
}

